import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb"
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import VivezVotreExperienceSection from "@/components/site-officiel/accueil/vivez-votre-experience-section";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle title={"Nos Inspirations Voyages"}
                       backgroundImgSrc={"/images/card-title/Inspirations-Voyages.jpg"}/>

            {/* Breadcrumb */}
            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Nos Inspirations Voyages</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                </div>
            </SectionPage>

            {/* Pourquoi venir en Côte d'Ivoire ? */}
            <SectionPage sectionType="2xl">
                <AwesomeCard title={"Pourquoi venir en Côte d'Ivoire ?"} className={"bg-white text-muted-foreground"}
                             titleClassName={"text-bleu-marine"}>
                    La Côte d’Ivoire, <span className={"font-bold"}>inspirante terre d’hospitalité</span>, vous ouvre chaleureusement ses portes pour vous
                    faire vivre des instants mémorables. Le visiteur y est roi et toutes les dispositions sont prises
                    pour lui souhaiter la bienvenue dès qu’il foule le sol de la terre d’Eburnie.
                    <br/><br/>
                    L’<span className={"font-bold"}>Akwaba</span> est célébré comme de coutume autour de réjouissances ; chants et danses rythmés par le son
                    des tam-tam, repas copieux colorés et épicés à base de viande, volaille et poisson accompagnés
                    d’Attiéké et d’Alloco, le savoureux vin de palme extrait de manière artisanale, la cola et le
                    piment.
                    <br/><br/>
                    Vous êtes bien arrivés à destination. Votre visite peut commencer sur ces notes enthousiastes de
                    gaité à l’endroit d’une population chaleureuse, d’une végétation généreuse encore vierge et
                    inexplorée par endroit, de plage époustouflante dont la pureté des eaux donne aux rayons du soleil
                    un éclat particulier, d’une faune diversifiée et surprenante.
                    <br/><br/>
                    Culturellement, vous serez bien servis par la pluralité de cette culture moderne à fort ancrage
                    traditionnel qui laisse de magnifiques empreintes artistiques ; monuments, musées, œuvres d’art,
                    musiques, danses, littérature etc, les témoins de l’immensité de notre savoir-faire.
                    <br/><br/>
                    Au son de notre musique Zouglou, vous vivrez des expériences inédites d’une contrée à une autre pour
                    un maximum d’émotion et d’émerveillement.
                    <br/><br/>
                    La Côte d’Ivoire, <span className={"font-bold"}>inspirante terre d’hospitalité</span>, aucune autre destination ne peut faire voyager
                    autant tous vos sens au cours d’un seul voyage.

                </AwesomeCard>
            </SectionPage>

            {/* galerie */}
            <SectionPage sectionType="2xl">
                <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 9 }).map((_, index) => ({
                                src: `/images/inspirations-voyages/galerie/${index + 1}.jpg`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-3 gap-4"} />
                    </div>
                </AwesomeCard>
            </SectionPage>


            <VivezVotreExperienceSection/>

        </div>
    );
}
